import { render } from "./SzAddress.vue?vue&type=template&id=922f9886&scoped=true"
import script from "./SzAddress.vue?vue&type=script&lang=ts"
export * from "./SzAddress.vue?vue&type=script&lang=ts"

import "./SzAddress.vue?vue&type=style&index=0&id=922f9886&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-922f9886"

export default script